const cards = [
  {
    tag: '深度追踪',
    title: '某顶流五年黑料全梳理：从出道到塌房的完整时间线',
    excerpt: '从选秀节目初露锋芒到如今的舆论风暴中心，我们梳理了这位顶流五年间不为人知的种种争议与内幕。',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20editorial%20photography%20of%20a%20spotlight%20on%20an%20empty%20stage%20with%20falling%20confetti%2C%20warm%20coral%20and%20golden%20tones%2C%20dramatic%20contrast%2C%20clean%20simple%20background%2C%20magazine%20spread%20style&width=600&height=400&seq=cards-01&orientation=landscape',
    alt: '深度追踪：某顶流五年黑料全梳理',
  },
  {
    tag: '综艺揭秘',
    title: '热门综艺的"剧本"有多厚？业内人士首次揭秘录制流程',
    excerpt: '你以为的真人秀真的是"真人"秀吗？从选角到冲突设计，业内人士详细拆解综艺节目的幕后运作机制。',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20modern%20television%20studio%2C%20cameras%20and%20lighting%20equipment%2C%20warm%20golden%20atmosphere%2C%20empty%20set%20with%20director%20chairs%2C%20clean%20minimalist%20composition%2C%20professional%20broadcast%20aesthetic&width=600&height=400&seq=cards-02&orientation=landscape',
    alt: '综艺揭秘：热门综艺幕后剧本',
  },
  {
    tag: '资本暗战',
    title: '娱乐公司对赌协议大起底：明星为何沦为资本棋子？',
    excerpt: '一份份对赌协议背后，折射出娱乐圈最残酷的生存法则。我们深度解析那些改变艺人命运的关键商业条款。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20documents%20and%20contracts%20with%20dollar%20signs%20floating%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20corporate%20intrigue%20mood%2C%20clean%20minimalist%20design%2C%20simple%20light%20background&width=600&height=400&seq=cards-03&orientation=landscape',
    alt: '资本暗战：对赌协议大起底',
  },
  {
    tag: '饭圈观察',
    title: '从狂热到坍塌：一个站姐眼中的偶像产业链真相',
    excerpt: '曾经为偶像花费数十万的资深站姐，揭秘饭圈文化的运作模式、集资内幕与偶像与粉丝之间的微妙关系。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20concept%20of%20a%20single%20figure%20in%20a%20crowd%20holding%20a%20glowing%20light%20stick%2C%20warm%20coral%20and%20golden%20ambient%20light%2C%20concert%20atmosphere%20abstract%2C%20minimalist%20clean%20background%2C%20emotional%20editorial%20photography&width=600&height=400&seq=cards-04&orientation=landscape',
    alt: '饭圈观察：站姐眼中的偶像产业链',
  },
  {
    tag: '时尚内幕',
    title: '红毯背后的品牌暗战：明星穿什么从来不是随机的',
    excerpt: '每一件红毯礼服背后都有一场看不见硝烟的战争。品牌代言、时尚资源与明星身价之间的复杂关系全解析。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20scene%20with%20abstract%20silhouettes%20and%20fashion%20elements%2C%20warm%20golden%20spotlights%2C%20luxurious%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20clean%20simple%20background%2C%20soft%20coral%20accents&width=600&height=400&seq=cards-05&orientation=landscape',
    alt: '时尚内幕：红毯品牌暗战',
  },
  {
    tag: '独家策划',
    title: '2024娱乐圈大事件复盘：那些改变行业格局的关键瞬间',
    excerpt: '从年初到年末，梳理今年最具影响力的娱乐圈大事件，分析它们如何深刻改变了中国娱乐产业的未来走向。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20collage%20of%20entertainment%20news%20headlines%20and%20abstract%20geometric%20shapes%2C%20warm%20coral%20and%20golden%20color%20palette%2C%20editorial%20design%20vibe%2C%20clean%20simple%20layout%2C%20minimalist%20composition&width=600&height=400&seq=cards-06&orientation=landscape',
    alt: '独家策划：2024娱乐圈大事件复盘',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          深度吃瓜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          不止于爆料，更关注事件背后的故事
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.alt}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {Math.floor(Math.random() * 50 + 10)}K 阅读
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {Math.floor(Math.random() * 500 + 100)} 评论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}